module.exports = __webpack_public_path__ + "assets/img/icon-5.db6c306f.png";